import type { ReactNode } from 'react';

import styles from '@/components/book/QuietState.module.css';

interface QuietStateProps {
  /** `quiet`: an aside (*Nothing is due.*). `loading`: *Opening…*. `none`: an empty result. */
  tone?: 'quiet' | 'loading' | 'none';
  children: ReactNode;
}

/** A single italic line where a list, a result or a body would be. */
export function QuietState({ tone = 'quiet', children }: QuietStateProps) {
  return (
    <p className={styles[tone]} role={tone === 'loading' ? 'status' : undefined}>
      {children}
    </p>
  );
}
